import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../../Extra/Loading";
import CASCemtIndent from "./CASCemtIndent";
import CASOtherIndent from "./CASOtherIndent";

const CASIndentMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [indentData, setIndentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const todayStr = new Date().toISOString().split("T")[0];
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
  const defaultFromStr = sevenDaysAgo.toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(defaultFromStr);
  const [toDate, setToDate] = useState(todayStr);
  const [statusAction, setStatusAction] = useState("pending");
  const [activePage, setActivePage] = useState("Cement Indent");
  const pages = ["Cement Indent", "Other Indent"];
  const handleBtnClick = (btnName) => {
    setActivePage(btnName);
  };
  const fetchIndent = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${urlPrefix}getMultipleTableData?hdr_table=t_indent_hdr&dtl_table=t_indent_dtls&hdr_pk=id&dtl_fk=ind_id&action=${statusAction}&date_column=order_date
&from_date=${fromDate}&to_date=${toDate}`,
      );

      if (response.status === 200) {
        const payload = response.data?.data || [];
        setIndentData(payload);
      }
    } catch (err) {
      console.error("API Error Encountered:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIndent();
  }, [fromDate, toDate, statusAction]);
  return (
    <div className="w-100 px-2">
      <div className="bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between mb-2">
        <h5 className="m-0">Indent Analysis Dashboard</h5>
      </div>

      <div className="mt-2">
        {loading && <Loading />}
        {error && (
          <div className="alert alert-danger m-0 p-2">
            <strong>Relational Mapping Error:</strong> ({error.message})
          </div>
        )}
        <div className="row">
          <div className="newUiBody">
            {pages.map((button, index) => {
              return (
                <button
                  key={index}
                  className={`btn btn-outline-dark m-1 ${
                    activePage === button && "active"
                  }`}
                  onClick={() => {
                    handleBtnClick(button);
                  }}
                >
                  {button}
                </button>
              );
            })}
          </div>
        </div>
        {activePage === "Cement Indent" && (
          <CASCemtIndent
            activeHead={activePage}
            data={indentData}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            statusAction={statusAction}
            setStatusAction={setStatusAction}
          />
        )}
        {activePage === "Other Indent" && (
          <CASOtherIndent
            activeHead={activePage}
            data={indentData}
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            statusAction={statusAction}
            setStatusAction={setStatusAction}
          />
        )}
      </div>
    </div>
  );
};

export default CASIndentMaster;
